module.exports = "/_next/static/images/OgGdpr-69c2fad6a79c0e12ead5b894d7f2eb27.png";